<template>
  <el-form class="source-form" :model="formSource" :rules="rules" ref="ruleFormAddCount" label-width="160px" :disabled="!edit">
    <el-form-item label="认证源名称" prop="name">
      <el-input v-model.trim="formSource.name" placeholder="请输入认证源名称" disabled></el-input>
    </el-form-item>
    <el-form-item label="是否启用" prop="enabled">
      <el-switch v-model="formSource.enabled"></el-switch>
    </el-form-item>
    <el-form-item label="企业ID" prop="corpId">
      <el-input v-model.trim="formSource.corpId" placeholder="请输入企业ID"></el-input>
      <p class="label-tips">
        钉钉开放平台->首页->CorpId
      </p>
    </el-form-item>
    <el-form-item label="Agent ID" prop="agentId">
      <el-input v-model.trim="formSource.agentId" placeholder="请输入AgentId"></el-input>
      <p class="label-tips">
        钉钉开放平台->应用开发->选择应用->凭证与基础信息->AgentId
      </p>
    </el-form-item>
    <el-form-item label="Client ID" prop="clientId">
      <el-input v-model.trim="formSource.clientId" placeholder="请输入Client ID"></el-input>
      <p class="label-tips">
        钉钉开放平台->应用开发->选择应用->凭证与基础信息->Client ID
      </p>
    </el-form-item>
    <el-form-item label="Client Secret" prop="secret">
      <el-input v-model.trim="formSource.secret" placeholder="请输入Client Secret"></el-input>
      <p class="label-tips">
        钉钉开放后台->应用开发->选择应用->凭证与基础信息->Client Secret
      </p>
    </el-form-item>
    <el-form-item label="回调地址" prop="wxip">
      <el-input v-model.trim="formSource.wxip" @input="change($event)" placeholder="企业的IDaaS登录地址" :disabled="!add"></el-input>
      <p class="label-tips">
        钉钉开放后台->应用开发->选择应用->安全设置->重定向URL
      </p>
    </el-form-item>
    <el-form-item label="账户关联设置" class="contact-rule" prop="createMethod">
      <template>
        <!-- <el-radio v-model="formSource.createMethod" label="1">手动关联IDaaS账户</el-radio>
        <el-radio v-model="formSource.createMethod" label="0">自动创建IDaaS账户</el-radio> -->
        <el-radio v-model="formSource.createMethod" label="2">自动绑定IDaaS账户</el-radio>
      </template>
    </el-form-item>
    <el-form-item label="邮箱后缀校验" prop="emailSuffix">
      <el-input v-model.trim="formSource.emailSuffix" placeholder="请输入邮箱后缀"></el-input>
      <p class="label-tips">
        钉钉用户邮箱后缀与设置的邮箱后缀匹配时，才能绑定IDaaS账户。设置多个后缀时，请用英文逗号（,）分隔
      </p>
    </el-form-item>
    <el-form-item>
      <div v-show="edit" class="footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="handleCancel">取 消</el-button>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
  import APIS from "@/apis/certificationSource.js"
  let wxip = ''
  export default {
    props: {
      formSource: {
        type: Object,
        default: () => {}
      },
      edit: {
        type: Boolean,
        default: true
      },
      add: {
        type: Boolean,
        default: false
      }
    },
    data() {
      // 检验wxip
      var checkWx = (rule, value, callback) => {
        if (wxip == "") {
          callback(new Error("请输入回调地址"))
        } else {
          callback()
        }
      }
      return {
        realmName: this.$realm,
        rules: {
          name: [{
            required: false,
            message: "请输入认证源名称",
            trigger: "blur"
          }],
          enabled: [{
            required: false,
            message: "请输入组名称",
            trigger: "blur"
          }],
          corpId: [{
            required: true,
            message: "请输入企业ID",
            trigger: "blur"
          }],
          agentId: [{
            required: true,
            message: "请输入AgentId",
            trigger: "blur"
          }],
          clientId: [{
            required: true,
            message: "请输入Client ID",
            trigger: "blur"
          }],
          secret: [{
            required: true,
            message: "请输入Client Secret",
            trigger: "blur"
          }],
          wxip: [{
            required: true,
            validator: checkWx,
            trigger: ["blur", 'change']
          }],
          createMethod: [{
            required: true,
            message: "请选择关联规则",
            trigger: "blur"
          }],
          emailSuffix: [{
            required: true,
            message: "请输入邮箱后缀",
            trigger: "blur"
          }]
        }
      }
    },
    created() {
      wxip = this.formSource.wxip
    },
    methods: {
      change(e) {
        wxip = e
        this.$forceUpdate()
      },
      resetForm() {
        this.$refs["ruleFormAddCount"].resetFields()
      },
      validateForm() {
        let validate = false
        this.$refs["ruleFormAddCount"].validate((valid) => {
          if (valid) {
            validate = true
          }
        })
        return validate
      },
      handleCancel() {
        this.$refs["ruleFormAddCount"].resetFields()
        if (!this.add) {
          this.$emit("changeStatus", true)
        } else {
          this.$router.back(-1)
        }
      },
      submitForm() {
        this.addProvider()
      },
      // 获取认证源基本信息
      async addProvider() {
        if (!this.validateForm()) {
          return false
        }
        let params = this.formSource,
          poxName = "addProvider"
        if (!this.add) {
          poxName = "editProvider"
          params.secret == "******" ? (params.secret = null) : ""
        }
        let {
          status
        } = await APIS[poxName](
          this.realmName, {
            data: params
          },
          this.formSource.providerId
        )
        if (status === 0) {
          if (this.add) {
            this.$router.push({
              path: `/certificationSource`
            })
          } else {
            this.$emit("changeStatus")
          }
        } else {
          if (!this.add) {
            this.$emit("changeStatus", true)
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .source-form {
    width: 515px;
    .contact-rule {
      .el-form-item__content {
        display: flex;
        flex-direction: column;
        p {
          width: 150%;
        }
        label {
          margin: 5px 0;
          margin-left: 0px;
        }
      }
    }
  }
</style>